var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.writeLayouts),function(writeLayout){return _c('member-write-link',{key:`memberComp${writeLayout}`,attrs:{"writeLayout":writeLayout,"memberData":_vm.memberData}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }